import { render } from "./KeyControllGuideForPlayer.vue?vue&type=template&id=a814e706"
import script from "./KeyControllGuideForPlayer.vue?vue&type=script&lang=js"
export * from "./KeyControllGuideForPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__